module.exports = __webpack_public_path__ + "img/09.f60e71c6.jpg";